'use client';

import { ReactNode, useEffect } from 'react';
import { Toaster } from "@/components/ui/toaster";

export function ProtectedBody({ children }: { children: ReactNode }) {
  // Add simplified client-side protection measures
  useEffect(() => {
    // List of form-related paths that should have minimal protection
    const formPaths = [
      '/contact',
      '/investor',
      '/investor-invitation',
      '/investor-action',
      '/partner'
    ];
    
    // Check if current page is a form page
    const isFormPage = formPaths.some(path => 
      typeof window !== 'undefined' && window.location.pathname.includes(path)
    );
    
    // Skip most protections on form pages
    if (isFormPage) {
      console.log('Form page detected - applying minimal content protection');
      return;
    }
    
    // Basic protection functions
    const handleContextMenu = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      
      // Allow right-click on form elements
      if (
        target.tagName === 'INPUT' || 
        target.tagName === 'TEXTAREA' || 
        target.tagName === 'SELECT' || 
        target.tagName === 'BUTTON' ||
        target.closest('form')
      ) {
        return true;
      }
      
      e.preventDefault();
      return false;
    };
    
    const handleSelectStart = (e: Event) => {
      const target = e.target as HTMLElement;
      
      // Allow selection on form elements
      if (
        target.tagName === 'INPUT' || 
        target.tagName === 'TEXTAREA' || 
        target.tagName === 'SELECT' || 
        (target.closest && target.closest('form'))
      ) {
        return true;
      }
      
      e.preventDefault();
      return false;
    };
    
    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      
      // Allow all keyboard interactions in form elements
      if (
        target.tagName === 'INPUT' || 
        target.tagName === 'TEXTAREA' || 
        target.tagName === 'SELECT' || 
        target.closest('form')
      ) {
        return true;
      }
      
      // Prevent only the most common shortcuts on non-form elements
      if (
        (e.ctrlKey && (
          e.key === 'c' || // Copy
          e.key === 's' || // Save
          e.key === 'p' || // Print
          e.key === 'u'    // View Source
        ))
      ) {
        e.preventDefault();
        return false;
      }
    };
    
    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('selectstart', handleSelectStart);
    document.addEventListener('keydown', handleKeyDown);
    
    // Clean up event listeners on unmount
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('selectstart', handleSelectStart);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  
  return (
    <div 
      style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        // @ts-ignore - msUserSelect is a valid CSS property
        msUserSelect: 'none',
        WebkitTouchCallout: 'none',
      }}
      className="protected-content"
    >
      {children}
      <Toaster />
    </div>
  );
}
